module.exports = __webpack_public_path__ + "img/BG_Desktop_Purple.4845e367.png";